/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InsightsExportEstimateSchemaAvailableSectionsItem } from './insightsExportEstimateSchemaAvailableSectionsItem';
import type { InsightsFormatPricingSchema } from './insightsFormatPricingSchema';

export interface InsightsExportEstimateSchema {
  credits_per_format: number;
  formats: InsightsFormatPricingSchema[];
  available_sections: InsightsExportEstimateSchemaAvailableSectionsItem[];
  already_paid?: boolean;
}
